import { API_CALL } from '../../../../middleware/api';
import { DEVICE_DETAILS, DEVICE_DETAILS_CLEAR } from './constants';

export const actions = {
  getCapsDetails: (id, pageRequest) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/esi/v1/caps/' + id,
      params: pageRequest,
    },
    type: DEVICE_DETAILS,
  }),

  getFillterData: deviceId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/caps/${deviceId}/event-types`,
    },
    type: 'GET_FILTER_DATA',
  }),
  clearCapsDetails: () => ({
    type: DEVICE_DETAILS_CLEAR,
  }),
};
